import images from "../Images";

const NotiInfo = {
  //user: [reaction, content, action, time, reacts count]
    ken: [images.haha, "picture", "Reacted", "20h", "1"],
    azossama: [images.angry, "comment: ksmk", "Reacted", "1h", "1"],
    didin: [images.love, "picture", "Reacted", "21m", "21"],
    aruma: [images.sad, "post", "Reacted", "1d", "5"],
    floppa: [images.wow, "post", "Reacted", "today", "4"],
    aymendjf: [images.care, "cover piture", "Reacted", "5h", "62"],
    kaori: [images.love, "profile picture", "Reacted", "5h", "2"],
    kai: [images.sad, "comment: hhh", "Reacted", "1h", "1"]
}


export default NotiInfo